import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMachineType,
  selectMachineType,
  setDataSuccess
} from 'src/features/staticDataSlice';
import MachineTypeCreateModal from 'src/pages/MachineType/MachineTypeCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function MachineTypeList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [machineTypeCreatePermission, setMachineTypeCreatePermission] = useState(false);

  const machineTypeData = useSelector(selectMachineType);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setMachineTypeCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('machineType', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchMachineType(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'machineType', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-machineType" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-machineType"
          id="select-machineType"
          value={tableListDatas[index]?.machineType || ''}
          onChange={(event) => {
            handleChange('machineType', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {machineTypeData?.map((machine) => (
            <MenuItem key={machine?.machineName} value={machine?.machineName}>
              {machine?.machineName}
            </MenuItem>
          ))}
          <Tooltip
            title={
              machineTypeCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Machine Type
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (machineTypeCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: machineTypeCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <MachineTypeCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default MachineTypeList;
